import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { DepartmentsListComponent } from './components/departments-list/departments-list.component';
import { ImageModalComponent } from './components/image-modal.component';
import { SitesListComponent } from './components/sites-list/sites-list.component';
import { TagLogPreviewComponent } from './components/tag-log-preview/tag-log-preview.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { ImageViewerDirective } from './directives/image-viewer.directive';
import { SpinnerComponent } from './modules';
import { DateFormatPipe, LocalDateFormatPipe, NgbTimePipe } from './pipes';
import { DateMomentPipe } from './pipes/date-moment.pipe';
import { FileHandlerComponent } from '../components/file-handler/file-handler.component';
import { FileManagerComponent } from '../components/file-manager/file-manager.component';
import { SafePipe } from '../core/pipe/safe.pipe';
import { SafeHtmlPipe } from '../core/pipe/safehtml2.pipe';
import { DragDropDirective } from '../components/directive/drag-drop.directive';
import { AutoCompleteComponent } from '../components/auto-complete/auto-complete.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule.forRoot(),
        AgGridModule.withComponents([]),
    ],
    declarations: [
        ImageModalComponent,
        ImageViewerDirective,
        SpinnerComponent,
        LocalDateFormatPipe,
        DateFormatPipe,
        DateMomentPipe,
        TagLogPreviewComponent,
        UsersListComponent,
        SitesListComponent,
        DepartmentsListComponent,
        NgbTimePipe,
        SafePipe,
        SafeHtmlPipe,
        FileHandlerComponent,
        FileManagerComponent,
        DragDropDirective,
        AutoCompleteComponent

    ],
    exports: [
        ImageModalComponent,
        ImageViewerDirective,
        SpinnerComponent,
        LocalDateFormatPipe,
        DateFormatPipe,
        DateMomentPipe,
        TagLogPreviewComponent,
        UsersListComponent,
        SitesListComponent,
        DepartmentsListComponent,
        NgbTimePipe,
        SafeHtmlPipe,
        SafePipe,
        DragDropDirective,
        FileHandlerComponent,
        FileManagerComponent,
        AutoCompleteComponent
    ],
    entryComponents: [
        ImageModalComponent
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts